import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';
import {isEmpty} from 'lodash';

import {fetchPersonalTrustpasses} from './personalTrustpassActions';

import PrivateRoute from '../../utils/PrivateRoute';
import PageNotFound from '../shared/components/notices/PageNotFound';

import PersonalTrustpassInformationContainer from './containers/personal/InformationContainer';

class PersonalTrustpassRoutes extends Component {
  componentDidMount() {
    if (isEmpty(this.props.personalTrustPass))
      this.props.dispatch(fetchPersonalTrustpasses(this.props.user_id));
  }

  render() {
    return (
      <Switch>
        <PrivateRoute
          exact
          path="/personal_trustpass/information/new"
          component={PersonalTrustpassInformationContainer}
        />
        <Route component={PageNotFound} />
      </Switch>
    );
  }
}

const mapStateToProps = state => {
  return {
    user_id: state.user.id,
    personalTrustPass: state.personal_trustpass,
  };
};

export default connect(mapStateToProps)(PersonalTrustpassRoutes);



// WEBPACK FOOTER //
// ./src/features/trustpass/ptpRoutes.js